/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trimbleItemsControllerBundleProjectSightDrawings } from "./trimbleItemsControllerBundleProjectSightDrawings";
import { trimbleItemsControllerListItems } from "./trimbleItemsControllerListItems";
import { trimbleItemsControllerListProjectSightContracts } from "./trimbleItemsControllerListProjectSightContracts";
import { trimbleItemsControllerListProjectSightDrawings } from "./trimbleItemsControllerListProjectSightDrawings";
import { trimbleItemsControllerListProjectSightProjects } from "./trimbleItemsControllerListProjectSightProjects";
import { trimbleItemsControllerMatchProjectSightDrawingsBundle } from "./trimbleItemsControllerMatchProjectSightDrawingsBundle";
import { trimbleItemsControllerStreamContent } from "./trimbleItemsControllerStreamContent";

export function trimbleService() {
  return { trimbleItemsControllerListItems, trimbleItemsControllerStreamContent, trimbleItemsControllerListProjectSightDrawings, trimbleItemsControllerMatchProjectSightDrawingsBundle, trimbleItemsControllerBundleProjectSightDrawings, trimbleItemsControllerListProjectSightProjects, trimbleItemsControllerListProjectSightContracts }
}